<template>
  <div class="page">
    <navigation
      :theme="{
        background:'#FD1519',
        color:'#fff',
      }"
      arrTheme='white'
    >
      <span>周三添财日</span>
      <span
        slot="right"
        class="rule-txt"
        @click="jumpRule"
      >活动规则</span>
    </navigation>
    <div class="container">
      <img
        src="./images/act2_img_biaoti@2x.png"
        class="title-image"
      >
      <div class="people-remain">
        <div class="number">{{detail.progress}}席</div>
        <div class="footer">名额仅剩</div>
      </div>
      <div class="info">
        <div class="count-down">
          距离活动结束仅剩
          <van-count-down :time="countDownTime">
            <template #default="timeData">
              <span class="block">{{ timeData.hours }}</span>
              <span class="colon">小时</span>
              <span class="block">{{ timeData.minutes }}</span>
              <span class="colon">分</span>
            </template>
          </van-count-down>
        </div>
        <scrollingNumber class="scrolling-number" />
        <img
          src="./images/btn_lijisuoding@2x.gif"
          class="lock-button BTN_NULL"
          data-sensors-click
          v-if="isEmptyString(detail.activeRecordStatus)"
          @click="lockQuota"
        >
        <img
          src="./images/btn_lijitixian@2x.gif"
          data-sensors-click
          class="lock-button BTN_NOT_USE"
          @click="withdraw"
          v-else-if="detail.activeRecordStatus==='NOT_USE'"
        >
        <img
          src="./images/btn_used@2x.png"
          class="lock-button"
          v-else-if="detail.activeRecordStatus==='USED'"
        >
      </div>
      <img
        src="./images/act2_img_tixian@2x.png"
        class="introduce-image"
      >
      <withdraw-user-flipper
        :background="'linear-gradient( 270deg, #FFC3BE 0%, #F7C91B 100%)'"
        :amountTextColor="'#FF4633'"
        :users="detail.rollingData"
        infoText="专属资金放款到账"
        v-if="detail.rollingData.length > 0"
      />
      <img
        src="./images/act2_img_dibu@2x.png"
        class="footer-image"
      >
    </div>
    <div
      class="dialog-card"
      v-if="showDialog"
      data-sensors-exposure-event-name="PopupDisplay"  
      data-sensors-exposure-property-caseId="dialog-card"
    >
      <i class="mask"></i>
      <img
        src="./images/dialog-bg.png"
        class="bg"
      >
      <div
        class="main-info"
        data-sensors-click
      >
        <img
          src="./images/icon_btn_withdraw@2x.png" class="withdraw-btn"
          data-sensors-click
          @click="withdraw"
        >
      </div>
      <img
        src="./images/btn_close@2x.png"
        class="close"
        @click="showDialog= false"
        data-sensors-click
      >
    </div>
  </div>
</template>

<script>
import withdrawUserFlipper from './components/withdraw-user-flipper.vue'
import scrollingNumber from '@/view/activities/wed-activities/components/scrolling-number'
import { mapActions } from 'vuex'
export default {
  components: {
    withdrawUserFlipper,
    scrollingNumber
  },
  data () {
    return {
      detail: {
        residue: 0,
        progress: '0',
        rollingData: [],
        activeRecordStatus: ''
      },
      showDialog: false
    }
  },
  computed: {
    countDownTime () {
      // 获取当前时间戳
      const now = new Date().getTime()
      return this.detail.residue - now
    }
  },
  async created () {
    await this.getDetail()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('activities', ['getActivityDetail', 'receiveActive']),
    jumpRule () {
      this.$router.push({
        path: '/act-two-rules'
      })
    },
    // 锁定席位（领取活动）
    async lockQuota () {
      const { success } = await this.receiveActive({
        activeCode: 'ACTIVE_BOX',
        subCode: 'ACTIVE_BOX_GOD_BLESS'
      })
      if (success) {
        this.showDialog = true
        await this.getDetail()
      }
    },
    // 获取活动详情
    async getDetail () {
      const { success, data } = await this.getActivityDetail({
        activeCode: 'ACTIVE_BOX',
        subCode: 'ACTIVE_BOX_GOD_BLESS'
      })
      if (success) {
        this.detail = data
      }
    },
    // 提现
    withdraw () {
      this.$router.push('/middle/limit')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

@keyframes flipAnimation {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(180deg);
  }
}
.page {
  background: linear-gradient(180deg, #fd1519 0%, #fffdf7 100%);
  min-height: 100vh;
  padding-bottom: 60px;
  .rule-txt {
    font-family: PingFangSC, PingFang SC;
    font-size: 28px;
    color: #ffffff;
    line-height: 40px;
    text-align: right;
    font-style: normal;
    margin-right: 40px;
    display: block;
  }
  .container {
    .title-image {
      width: 537px;
      margin-top: 104px;
      margin-left: 107px;
    }
    .people-remain {
      background: url("./images/act2_img_jindu@2x.png") no-repeat;
      background-size: 100% 100%;
      width: 110px;
      height: 110px;
      position: fixed;
      top: 410px;
      right: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      line-height: 28px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      .number {
        margin-top: 37px;
      }
      .footer {
        margin-top: 12px;
      }
    }
    .info {
      background: url("./images/act2_img_mao@2x.png") no-repeat;
      background-size: 100%;
      margin-top: 6px;
      width: 750px;
      height: 1080px;
      .count-down {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 26px;
        color: #ffffff;
        line-height: 37px;
        margin-top: 37px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        display: flex;
        justify-content: center;
        .van-count-down {
          display: flex;
          align-items: center;
          .block {
            color: #ff4633;
            background-color: #ffd9d9;
            border-radius: 4px;
            font-size: 26px;
            width: 36px;
            height: 36px;
            line-height: 36px;
            margin-left: 9px;
            margin-right: 9px;
            text-align: center;
            display: block;
          }
          .colon {
            color: #fff;
            font-size: 26px;
          }
        }
      }
      .scrolling-number {
        margin-top: 670px;
      }
      .lock-button {
        width: 640px;
        height: 160px;
        margin-left: 55px;
        margin-top: 5px;
      }
    }
    .introduce-image {
      width: 652px;
      margin-top: 30px;
      margin-left: 49px;
    }

    .footer-image {
      margin-top: 66px;
      width: 302px;
      margin-left: 224px;
    }
  }
  .dialog-card {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999999;
    .mask {
      background: rgba(0, 0, 0, 0.9);
      position: absolute;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
    }
    .main-info {
      background: url("./images/img_popup_lock_quota@2x.png") no-repeat;
      background-size: 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 520px;
      height: 640px;
      text-align: center;
      animation: zoomIn 0.3s linear;
      .withdraw-btn {
        width: 473px;
        height: 150px;
        margin-top: 459px;
      }
    }
    .bg {
      width: 710px;
      height: 710px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      animation: rotates 1s infinite linear;
    }
    @keyframes rotates {
      0% {
        transform: translate(-50%, -50%) rotateZ(0deg);
      }
      100% {
        transform: translate(-50%, -50%) rotateZ(360deg);
      }
    }
    @keyframes zoomIn {
      0% {
        transform: translate(-50%, -50%) scale(0.3);
      }
      100% {
        transform: translate(-50%, -50%) scale(1);
      }
    }
    .close {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-top: 460px;
      width: 60px;
      height: 60px;
      cursor: pointer;
    }
  }
}
</style>
